var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#F9B300"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8707 26.7858H37.9252C39.0438 26.7858 40.1166 27.2373 40.9075 28.041C41.6985 28.8448 42.1429 29.9348 42.1429 31.0715C42.1429 32.2081 41.6985 33.2982 40.9075 34.1019C40.1166 34.9057 39.0438 35.3572 37.9252 35.3572H36.8707M36.8707 26.7858H20V36.4286C20 37.5653 20.4444 38.6554 21.2353 39.4591C22.0263 40.2628 23.0991 40.7143 24.2177 40.7143H32.6531C33.7717 40.7143 34.8444 40.2628 35.6354 39.4591C36.4264 38.6554 36.8707 37.5653 36.8707 36.4286V26.7858ZM24.2177 19.2858V22.5001M28.4354 19.2858V22.5001M32.6531 19.2858V22.5001",
    stroke: "white",
    strokeWidth: 2.12553,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.3b710466a3e25154201431d8781e88e3.svg";
export { ForwardRef as ReactComponent };